import { Language } from '../../enums/language.enum';
import { translatedPaths } from '../translated-paths';

export function getTranslatedRoutePath(path: symbol, language: Language): string {
	const pathTranslationRecord = translatedPaths.get(path);

	if (!pathTranslationRecord) {
		throw new Error(`No translated path found for symbol "${path.toString()}"`);
	}

	return pathTranslationRecord[language];
}
